import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: '',
    loadComponent: async () => import('./order-list/order-list.component').then(m => m.OrderListComponent)
  },
  {
    path: ':id',
    loadComponent: async () => import('./order/order.component').then(m => m.OrderComponent)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrdersRoutingModule { }
